import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "antd";
import { findParents, searchTree } from "helpers/utility";
import CIcon from "components/CIcon";

const CMenu = (props) => {
  const { dataSource, collapsed } = props;
  const { pathname } = useLocation();
  const [openKeys, setOpenKeys] = useState([]);
  const [selectedKey, setSelectedKey] = useState();

  const handleOpenChanged = (keys) => {
    setOpenKeys(keys);
  };
  const handleSelect = ({ key }) => {
    setSelectedKey(key);
  };

  const renderMenuItem = (item) => {
    const { children, label, url, menuID, cssClass } = item;
    if (item.children.length > 0) {
      return (
        <Menu.SubMenu
          key={menuID}
          title={label}
          icon={cssClass && <CIcon type={cssClass} />}
        >
          {children.map(renderMenuItem)}
        </Menu.SubMenu>
      );
    }

    return (
      <Menu.Item key={menuID} icon={cssClass && <CIcon type={cssClass} />}>
        <Link to={`${url || ""}`}>
          <span>
            <span className="nav-text">{label}</span>
          </span>
        </Link>
      </Menu.Item>
    );
  };

  useEffect(() => {
    const key = searchTree(
      [{ children: dataSource }],
      "url",
      "children",
      pathname
    );
    if (key && key.menuID) {
      setSelectedKey(key.menuID.toString());

      const keys = findParents(
        dataSource,
        "menuID",
        "children",
        key.menuID
      ).map((x) => x.toString());

      setOpenKeys(keys);
    }
  }, [dataSource, pathname]);

  return (
    <Menu
      mode="inline"
      theme="dark"
      selectedKeys={[selectedKey]}
      onSelect={handleSelect}
      openKeys={openKeys}
      onOpenChange={handleOpenChanged}
      inlineCollapsed={collapsed}
    >
      {dataSource.map(renderMenuItem)}
    </Menu>
  );
};

CMenu.propTypes = {
  dataSource: PropTypes.array,
  collapsed: PropTypes.bool,
};

export default CMenu;
